import {Component, Input} from '@angular/core';
import {CustomerWizardResponse} from '../../../../../../domain/data/customer-wizard-response.data';
import {VehicleBrand} from '../../../../../../domain/core/vehicle-brand.model';
import {StripHtmlPipe} from '../../../../../../shared/pipes/strip-html.pipe';

@Component({
  selector: 'app-wizard-dig-sig-communication',
  imports: [
    StripHtmlPipe
  ],
  templateUrl: './wizard-dig-sig-communication.component.html',
  standalone: true
})
export class WizardDigSigCommunicationComponent {
  @Input() brand: VehicleBrand;
  @Input() customerWizardResponse: CustomerWizardResponse;

  protected readonly VehicleBrand = VehicleBrand;

  getContactEvent(key: string) {
    if (!this.customerWizardResponse?.contactEventList) {
      return null;
    }

    for (const e of this.customerWizardResponse.contactEventList) {
      if (e.eventName === key) {
        return e;
      }
    }
    return null;
  }
}
